module.exports = __webpack_public_path__ + "img/ocean-resort-3.39c01541.jpg";